import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as swalReducer } from 'react-redux-sweetalert';
import { localeReducer as locale } from 'react-localize-redux';
// import testReducer from './test_reducer';
import authReducer from './auth_reducer';
import layoutReducer from './layout_reducer';
import blogReducer from './blog_reducer';
import cartReducer from './cart_reducer';
import chatReducer from './chat_reducer';
import coinReducer from './coin_reducer';
import commentReducer from './comment_reducer';
import commonReducer from './common_reducer';
import couponReducer from './coupon_reducer';
import creditCardReducer from './creditcard_reducer';
import flashsaleReducer from './flashsale_reducer';
import giveawayReducer from './giveaway_reducer';
import itemCategoryReducer from './item_category_reducer';
import materialReducer from './material_reducer';
import miscReducer from './misc_reducer';
import notificationReducer from './notification_reducer';
import orderReducer from './order_reducer';
import profileReducer from './profile_reducer';
import reviewReducer from './review_reducer';
import searchReducer from './search_reducer';
import storeLocationReducer from './store_location_reducer';
import seoReducer from './seo_reducer';
import the1Reducer from './the1_reducer'
import topSpenderReducer from './topspender_reducer';
import webConfigReducer from './webconfig_reducer'

const rootReducer = combineReducers({
    auth: authReducer,
    layout: layoutReducer,
    blog: blogReducer,
    cart: cartReducer,
    chat: chatReducer,
    coin: coinReducer,
    comments: commentReducer,
    common: commonReducer,
    coupon: couponReducer,
    creditCard: creditCardReducer,
    flashsale: flashsaleReducer,
    form: formReducer,
    giveaway: giveawayReducer,
    itemCategories: itemCategoryReducer,
    materials: materialReducer,
    misc: miscReducer,
    notice: notificationReducer,
    orders: orderReducer,
    prof: profileReducer,
    review: reviewReducer,
    search: searchReducer,
    storeLocation: storeLocationReducer,
    sweetalert: swalReducer,
    seo: seoReducer,
    the1: the1Reducer,
    topSpender: topSpenderReducer,
    webConfig: webConfigReducer,
    locale: locale,
});

export default rootReducer;